<script setup lang="ts">
import { useMetaData } from "~/composables/useMetaData";
import { MEDIA_SECTIONS } from "~/layers/media/composables/useMediaPagination";

definePageMeta({
  layout: "media",
});

// Первая страница акций живёт на /sales без номера, вторая и дальше —
// на /sales/page2 (sales/page[page].vue). IT-1253.
const { seoTitle, seoDescription } = MEDIA_SECTIONS.sales;

const META_DATA = computed(() => {
  return {
    og: {
      component: "Frame",
      title: seoTitle,
      description: seoDescription,
      logo: "https://atlasgroup.su/uploads/main/009/bf4c6ab88c322a476fed0d22e3ef5bf9f5782259ca962d56edea638edc678ece/logo.svg",
      url: "www.atlasgroup.su",
      bg: "linear-gradient(to bottom right, #091536, black)",
    },
    meta: {
      title: seoTitle,
      "theme-color": "#ffffff",
      description: seoDescription,
      author: "Атлас Девелопмент",
      robots: "index, follow",
      og_title: seoTitle,
      og_description: seoDescription,
      og_url: "https://atlasdevelopment.su/",
      og_type: "website",
      tw_title: seoTitle,
      tw_description: seoDescription,
      tw_url: "https://atlasdevelopment.su/",
    },
  };
});
useMetaData(META_DATA);
useHead({
  script: [
    {
      type: "application/ld+json",
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "CollectionPage",
        name: "Акции",
        description:
          "Специальные предложения и акции от застройщика Атлас Девелопмент. Скидки на квартиры, ипотечные программы, рассрочка.",
        url: "https://atlasdevelopment.su/sales",
        mainEntity: {
          "@type": "ItemList",
          name: "Акции и спецпредложения Атлас Девелопмент",
          description: "Актуальные акции и скидки на квартиры в новостройках Атлас Девелопмент.",
        },
        breadcrumb: {
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Главная",
              item: "https://atlasdevelopment.su/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Акции",
            },
          ],
        },
      }),
    },
  ],
});
</script>

<template>
  <h1 class="sr-only">Акции</h1>
  <MediaSectionList section="sales" :page="1" />
</template>
